import { render, staticRenderFns } from "./ColonQualityReport.vue?vue&type=template&id=f2475632&scoped=true"
import script from "./ColonQualityReport.vue?vue&type=script&lang=js"
export * from "./ColonQualityReport.vue?vue&type=script&lang=js"
import style0 from "./ColonQualityReport.vue?vue&type=style&index=0&id=f2475632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2475632",
  null
  
)

export default component.exports